import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap';
import { SecurityService } from '../../services/security.service';
import { SecurityUser } from '../../beans/SecurityUser';
import { StorageService } from '../../services/storage.service';

@Component({
	selector: 'app-security-users',
	templateUrl: './security-users.component.html',
	styleUrls: ['./security-users.component.scss']
})
export class SecurityUsersComponent implements OnInit {

	users: SecurityUser[] = [];
	message: string = '';

	mailingEnabled: boolean = false;
	mailingLoaded: boolean = false;

	@ViewChild('previewModal') previewModal: ModalDirective;
	previewUser: SecurityUser = null;
	previewLoading = false;
	previewItems: any[] = [];

	// за формата за регистрация
	newUser = {
		username: '',
		password: '',
		names: '',
		email: '',
		phone: '',
		role: 'ROLE_USER'
	};

	constructor(
		private securityService: SecurityService,
		private storageService: StorageService,
		private router: Router
	) { }

	ngOnInit() {
		this.loadUsers();
		this.loadMailingState();
	}

	loadUsers() {
		this.securityService.listUsers().subscribe(res => {
			this.users = res.sort((a, b) =>
				(a.names || '').localeCompare(b.names || '', 'bg')
			);
		});
	}

	loadMailingState() {
		this.securityService.getMailingEnabled().subscribe(res => {
			this.mailingEnabled = !!(res && res.enabled);
			this.mailingLoaded = true;
		});
	}

	toggleMailing() {
		const newValue = !this.mailingEnabled;
		const confirmMsg = newValue
			? 'СИГУРНИ ЛИ СТЕ? Това ще ВКЛЮЧИ изпращането на email-и за всички потребители с включена опция "Иска нотиф.".'
			: 'Изключване на глобалния email switch. Никакви email-и няма да излизат докато не го включите отново.';
		if (!confirm(confirmMsg)) {
			return;
		}
		this.securityService.changeMailingEnabled(newValue).subscribe(_ => {
			this.mailingEnabled = newValue;
			this.message = newValue
				? '✉ Глобалният мейлинг е ВКЛЮЧЕН'
				: '🚫 Глобалният мейлинг е ИЗКЛЮЧЕН';
		}, err => {
			this.message = '❌ ' + ((err && err.error && err.error.message) || 'Грешка при смяна на switch-a');
		});
	}

	register() {
		this.securityService.registerUser(
			this.newUser.username,
			this.newUser.password,
			this.newUser.names,
			this.newUser.email,
			this.newUser.phone,
			this.newUser.role
		).subscribe(_ => {
			this.message = 'Потребител създаден успешно!';
			this.loadUsers();
		}, err => this.message = err.error.message || 'Грешка');
	}

	changePassword(u: any) {
		const pass = window.prompt('Нова парола за ' + u.username);
		if (!pass) return;

		this.securityService.changePassword(u.username, pass)
			.subscribe({
				next: _ => {
					this.message = 'Паролата е сменена успешно.';
					this.loadUsers();
				},
				error: err => {
					// backend message e .message или .error.message
					let backendMessage = err.error.message;
					this.message = "❌ " + backendMessage;
					console.error('changePassword error:', err);
				}
			});
	}

	changeRole(u: any) {
		const newRole = (u.authority === 'ROLE_ADMIN' ? 'ROLE_USER' : 'ROLE_ADMIN');

		this.securityService.changeUserAuthority(u.username, newRole)
			.subscribe(_ => {
				this.message = 'Ролята е сменена';
				this.loadUsers();  // 🔥 презарежда данните от backend
			});
	}

	changeBulins(u: SecurityUser) {
		let newValue = !u.bulinsAuthority;

		this.securityService.changeUserBulinsAuthority(u.username, newValue).subscribe(_ => {
			this.message = 'Bulins правата обновени';
			this.loadUsers();
		});
	}

	unlock(u: any) {
		this.securityService.unlockUser(u.username)
			.subscribe(_ => {
				this.message = 'Потребителят е отключен';
				this.loadUsers(); // 🔥 Презарежда новото locked състояние
			});
	}

	activate(u: SecurityUser) {
		let newValue = !u.enabled;

		this.securityService.activateUser(u.username, newValue).subscribe(_ => {
			this.message = 'Акаунтът е активиран/деактивиран';
			this.loadUsers();
		});
	}
	refresh() {
		this.message = "";
		this.loadUsers();
	}

	changeNdo(u: any) {
		const newVal = !u.isNDO;

		this.securityService.changeUserNdo(u.username, newVal)
			.subscribe(_ => {
				this.message = 'NDO сменено';
				this.loadUsers(); // 🔥 обновява UI
			});
	}
	
	changeColor(u: SecurityUser, color: string) {
		this.securityService.changeColor(u.username, color).subscribe(_ => {
			this.message = 'Цветът е обновен';
			this.loadUsers();
		});
	}

	changeEmailVerified(u: SecurityUser) {
		const newValue = !u.emailVerified;
		this.securityService.changeEmailVerified(u.username, newValue).subscribe(_ => {
			this.message = 'Email verified обновено';
			this.loadUsers();
		});
	}

	changeWantsNotifications(u: SecurityUser) {
		const newValue = !u.wantsNotifications;
		this.securityService.changeUserWantsNotifications(u.username, newValue).subscribe(_ => {
			this.message = 'Нотификациите са ' + (newValue ? 'включени' : 'изключени');
			this.loadUsers();
		});
	}

	changeIncludesInLawyerWorkload(u: SecurityUser) {
		const newValue = !u.includesInLawyerWorkload;
		this.securityService.changeIncludesInLawyerWorkload(u.username, newValue).subscribe(_ => {
			this.message = 'Excel натовареност: ' + (newValue ? 'включен' : 'изключен');
			this.loadUsers();
		});
	}

	changeDashboardVisible(u: SecurityUser) {
		const newValue = !u.dashboardVisible;
		this.securityService.changeDashboardVisible(u.username, newValue).subscribe(_ => {
			this.message = 'Dashboard: ' + (newValue ? 'видим' : 'скрит');
			this.loadUsers();
		});
	}

	openPreview(u: SecurityUser) {
		this.previewUser = u;
		this.previewItems = [];
		this.previewLoading = true;
		this.previewModal.show();
		this.securityService.previewNotificationsForUser(u.id).subscribe(
			data => {
				this.previewItems = data || [];
				this.previewLoading = false;
			},
			err => {
				this.previewLoading = false;
				let msg = 'Грешка при зареждане на preview.';
				if (err && err.error && err.error.message) {
					msg = err.error.message;
				}
				this.message = '❌ ' + msg;
			}
		);
	}

	closePreview() {
		this.previewModal.hide();
		this.previewUser = null;
		this.previewItems = [];
	}

	/**
	 * Групира previewItems по scheduledDate — scheduler-ът обединява всички
	 * напомняния на един user за един ден в ЕДНО писмо. Тук показваме същото
	 * групиране визуално: header банер „N напомняния → 1 писмо за DATE",
	 * следван от картичките на тази дата.
	 */
	get previewGroups(): { scheduledDate: string, items: any[] }[] {
		const groups: { scheduledDate: string, items: any[] }[] = [];
		const byDate: { [date: string]: any[] } = {};
		for (const p of this.previewItems) {
			const d = p.scheduledDate || '';
			if (!byDate[d]) {
				byDate[d] = [];
				groups.push({ scheduledDate: d, items: byDate[d] });
			}
			byDate[d].push(p);
		}
		return groups;
	}

	/**
	 * Heat-map фон за preview-картичка по разстояние до scheduledDate:
	 * близките дати са по-„топли" (амбър), далечните — почти бели.
	 * Помага на админа да схване кои имейли са спешни без да чете дати.
	 */
	bgForScheduledDate(scheduledDate: string): string {
		if (!scheduledDate) {
			return '#fafafa';
		}
		// Парсваме като local date (YYYY-MM-DD), за да избегнем UTC off-by-one.
		const parts = scheduledDate.split('-').map(s => parseInt(s, 10));
		if (parts.length !== 3 || isNaN(parts[0])) {
			return '#fafafa';
		}
		const sched = new Date(parts[0], parts[1] - 1, parts[2]);
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		sched.setHours(0, 0, 0, 0);
		const days = Math.round((sched.getTime() - today.getTime()) / 86400000);

		if (days <= 0) { return '#ffe0a0'; }   // днес (или просрочено)
		if (days === 1) { return '#fff0d0'; }  // утре
		if (days === 2) { return '#fff5dd'; }  // вдругиден
		if (days <= 6) { return '#fff8e8'; }   // тази седмица
		if (days <= 13) { return '#fffbf0'; }  // следваща седмица
		return '#fefdfa';                       // по-нататък
	}

	impersonate(u: SecurityUser) {
		if (!confirm('Влизане като ' + u.username + '?')) return;

		this.securityService.impersonate(u.username).subscribe({
			next: (loginResponse) => {
				this.storageService.setLoginResponse(loginResponse);
				this.storageService.removePasswordMessage();
				this.router.navigateByUrl('/cases');
			},
			error: err => {
				this.message = '❌ ' + (err.error.message || 'Грешка при impersonation');
			}
		});
	}

	editField(u: any, field: string) {
	const current = u[field] || '';
	const label = field === 'names' ? 'Имена' :
		          field === 'email' ? 'Email' : 'Телефон';

	const newValue = window.prompt('Нова стойност за ' + label + ':', current);

	// Ако cancel → нищо не правим
	if (newValue === null) return;

	this.securityService.updateUserFields(
		u.username,
		field === 'names' ? newValue : undefined,
		field === 'email' ? newValue : undefined,
		field === 'phone' ? newValue : undefined
	).subscribe({
		next: _ => {
			this.message = label + ' обновени успешно!';
			this.loadUsers(); // 🔥 обновяване
		},
		error: err => {
			let msg = err.error.message;
			this.message = '❌ ' + msg;
			console.error(err);
		}
	});
}


}
